import { RouteRecordRaw } from 'vue-router';

export const zelosRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/ZelosLayout.vue'),
    meta: { scope: 'zelos', title: 'Zelos' },
    children: [
      { path: '', name: 'zelos.home', component: () => import('../pages/Home.vue') },
      { path: 'versender', name: 'zelos.versender', component: () => import('../pages/Versender.vue') },
      { path: 'empfaenger', name: 'zelos.empfaenger', component: () => import('../pages/Empfaenger.vue') },
    ],
  },
];
